import React from 'react';

import { Progress, useMantineTheme } from '@mantine/core';

import { type Component, ComponentDisplayName } from '@root/lib/types/components';

import type { LoadingProgressProps } from './LoadingProgress.types';

/**
 * LoadingProgress component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const LoadingProgress: Component<LoadingProgressProps> = ({ provider, ...props }) => {
	const { progress, loaded, setLoaded, exitTransitionDuration, transitionDuration } = provider;
	const theme = useMantineTheme();

	React.useEffect(() => {
		setLoaded(true);
		return () => {
			setLoaded(false);
		};
	}, [setLoaded]);

	return (
		<Progress
			radius={0}
			value={progress}
			size="xs"
			classNames={{ root: 'absolute!' }}
			styles={{
				root: {
					top: 0,
					left: 0,
					right: 0,
					zIndex: 999,
					backgroundColor: 'transparent',
					transitionProperty: 'opacity',
					transitionDuration: `${exitTransitionDuration}ms`,
					opacity: loaded ? 1 : 0,
				},
				section: {
					position: 'relative',
					transitionProperty: 'width',
					transitionDuration: `${transitionDuration}ms`,
				},
			}}
			{...props}
		/>
	);
};

/**
 * LoadingProgress component display name
 * @type {ComponentDisplayName}
 */
LoadingProgress.displayName = 'component/LoadingProgress';
